var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptTextSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt-text-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.3333 12.5V17.5416C46.3333 20.8333 44.25 22.9166 40.9583 22.9166H33.8333V8.35413C33.8333 6.04163 35.7291 4.16663 38.0416 4.16663C40.3125 4.18746 42.3958 5.10413 43.8958 6.60413C45.3958 8.12496 46.3333 10.2083 46.3333 12.5Z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66669 14.5833V43.75C4.66669 45.4791 6.62498 46.4583 7.99998 45.4166L11.5625 42.75C12.3959 42.125 13.5625 42.2083 14.3125 42.9583L17.7708 46.4375C18.5833 47.25 19.9167 47.25 20.7292 46.4375L24.2292 42.9375C24.9584 42.2083 26.125 42.125 26.9375 42.75L30.5 45.4166C31.875 46.4375 33.8334 45.4583 33.8334 43.75V8.33329C33.8334 6.04163 35.7084 4.16663 38 4.16663H15.0834H13C6.75002 4.16663 4.66669 7.89579 4.66669 12.5V14.5833Z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M13 18.75H25.5",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M14.5625 27.0834H23.9375",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptTextSvgrepoCom1);
export default __webpack_public_path__ + "static/media/receipt-text-svgrepo-com 1.833e90c1c20bdad5f4c637557fa64cf4.svg";
export { ForwardRef as ReactComponent };